import React, { useState, useEffect, useMemo } from "react";
import "./Products.css";
import { useNavigate } from "react-router-dom";
import axiosConfig from "../../Service/axiosConfig";
import { addProduct, removeProduct, addToRentCart, removeFromRentCart, selectRentCart, addWishlist, removeWishlist } from "../../redux/Slices/cartSlice";
import { useSelector, useDispatch } from "react-redux";
import { FiChevronLeft, FiChevronRight, FiEdit2, FiTrash2 } from "react-icons/fi";
import { AccessDeny, LocationModal } from "../PopupModal";
import { useParams } from "react-router-dom";
import { BreadCrumbs } from "../BreadCrums";
import WishlistIcon from "../Wishlist";
import { Products } from "../Products";
import { AiFillCaretRight, AiFillHeart, AiOutlineHeart } from "react-icons/ai";
import ProductMultipleImages from "./ProductMultipeImages";
import { TiTick } from "react-icons/ti";
import { toast } from "react-toastify";
import ConfigureRentalModal, { ALL_PLANS, getPackageForPlan } from "./ConfigureRentalModal";
import { LoginModal } from "../LoginModal/LoginModal";

/* ── Helpers ── */
const RENT_CONFIG_STORAGE_KEY = "bgb_rentConfigurations";

function loadStoredConfigs(variantId) {
  try {
    const all = JSON.parse(localStorage.getItem(RENT_CONFIG_STORAGE_KEY) || "{}");
    return Array.isArray(all[variantId]) ? all[variantId] : [];
  } catch {
    return [];
  }
}

function saveStoredConfigs(variantId, configs) {
  try {
    const all = JSON.parse(localStorage.getItem(RENT_CONFIG_STORAGE_KEY) || "{}");
    all[variantId] = configs;
    localStorage.setItem(RENT_CONFIG_STORAGE_KEY, JSON.stringify(all));
  } catch { /* ignore */ }
}

const ALL_CANONICAL_PLANS = [
  { key: "daily", label: "Daily", period: "Day" },
  { key: "weekly", label: "Weekly", period: "Week" },
  { key: "monthly", label: "Monthly", period: "Month" },
  { key: "annually", label: "Annually", period: "Year" },
];

const formatDurationDisplay = (duration, planKey) => {
  const key = (planKey || "").toLowerCase().trim();
  let planMeta = ALL_PLANS.find((p) => p.key === key);
  if (!planMeta) {
    planMeta = ALL_PLANS.find(
      (p) => key.includes(p.key) || key.includes(p.label.toLowerCase())
    );
  }
  if (!planMeta) planMeta = ALL_PLANS[0];
  return `${duration} ${duration === 1 ? planMeta.unit : planMeta.unitPlural}`;
};

const formatRupee = (value) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return "Quote on request";
  return `$${number.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

const stripHtml = (html = "") => html.replace(/<[^>]*>/g, "").trim();

const ProductDetail = (props) => {
  const { Setlogin, LoginAccount, item, setIsDeleted } = props;
  const { cart } = useSelector((state) => state);
  const rentCart = useSelector(selectRentCart);
  const dispatch = useDispatch();

  const [LocationpopupType, setLocationpopupType] = useState("");
  const [NoAccess, setNoAccess] = useState("");
  const [brandName, setBrandName] = useState(null);
  const [shopdeals, setShopDeals] = useState(null);
  const [loginShow, setLoginShow] = useState(false);
  const resolveFirstImage = (it) =>
    it?.images?.[0]?.image?.image ||
    it?.image?.image ||
    "";
  const [Image, setImage] = useState(() => resolveFirstImage(item));
  const [showMessage, setShowMessage] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState(false);
  const [selectedImage, setSelectedImage] = useState(() => resolveFirstImage(item));

  let { friendlyurl } = useParams();
  let navigate = useNavigate();

  /* ── Buy / Rent mode ── */
  const [orderMode, setOrderMode] = useState(() => {
    const stored = localStorage.getItem("listingType");
    return stored === "rent" ? "rent" : "buy";
  });

  /* ── Wishlist State ── */
  const [inWishlist, setInWishlist] = useState(false);
  const [wishlistId, setWishlistId] = useState(null);
  let userId = localStorage.getItem("userId") || localStorage.getItem("userid");

  useEffect(() => {
    if (!item?.id) return;
    axiosConfig.get(`/catlog/wishlist-check/?variant_id=${item.id}&type=${orderMode}`)
      .then(res => {
        if (res.data) {
          setInWishlist(res.data.in_wishlist);
          setWishlistId(res.data.id);
        }
      })
      .catch(err => console.error("Error checking wishlist", err));
  }, [item?.id, orderMode]);

  const toggleWishlist = () => {

    if (!localStorage.getItem("token")) {
      setLoginShow(true);
      return;
    }
    const apiType = orderMode === "rent" ? "rental" : "sale";

    if (inWishlist) {
      if (!wishlistId) return;
      axiosConfig.delete(`/catlog/wishlists/${wishlistId}/`)
        .then(() => {
          setInWishlist(false);
          setWishlistId(null);
          dispatch(removeWishlist({ productId: item.id, type: apiType }));
          toast.success("Removed from wishlist");
          if (typeof setIsDeleted === 'function') {
            setIsDeleted(true);
          }
        });
    } else {
      axiosConfig.post(`/catlog/wishlists/`, { user: userId, varient: item.id, type: apiType })
        .then(res => {
          setInWishlist(true);
          setWishlistId(res.data.id);
          dispatch(addWishlist({
            productId: item.id,
            wish_id: res.data.id,
            type: apiType
          }));
        });
      toast.success("Added to wishlist");
    }
  };

  /* ── Rental plan & packages ── */
  const [rentalPlan, setRentalPlan] = useState("weekly");
  const [pricePackages, setPricePackages] = useState([]);

  /* ── Rental configurations ── */
  const [rentConfigurations, setRentConfigurations] = useState([]);
  const [showConfigureModal, setShowConfigureModal] = useState(false);
  const [editingConfigId, setEditingConfigId] = useState(null);

  /* ── Derived prices ── */
  const isRentMode = orderMode === "rent";
  const itemPrice = isRentMode
    ? (item.prices?.rental_price || item.rental_price || item.prices?.sale_price || item.sale_price || item.price)
    : (item.prices?.sale_price || item.sale_price || item.price);
  const itemOfferPrice = isRentMode
    ? (item.prices?.rental_offer_price || item.rental_offer_price || itemPrice)
    : (item.prices?.sale_offer_price || item.sale_offer_price || item.offer_price);

  const activePackage = getPackageForPlan(pricePackages, rentalPlan);
  const currentPlan = ALL_CANONICAL_PLANS.find((p) => p.key === rentalPlan) || ALL_CANONICAL_PLANS[1];
  const displayRentPrice = activePackage ? formatRupee(activePackage.offer_price) : formatRupee(itemPrice);
  const rentHasDiscount = activePackage
    && Number(activePackage.price) > Number(activePackage.offer_price)
    && Number(activePackage.offer_price) > 0;

  const hasBuyDiscount = itemOfferPrice && itemOfferPrice !== itemPrice
    && Number(itemOfferPrice) > 0 && Number(itemPrice) > Number(itemOfferPrice);
  const displayBuyPrice = hasBuyDiscount ? formatRupee(itemOfferPrice) : formatRupee(itemPrice);
  const originalBuyPrice = hasBuyDiscount ? formatRupee(itemPrice) : null;

  /* ── Description ── */
  const description = stripHtml(item?.description || "");
  const shortDescText = (() => {
    if (!description) return "";
    const sentences = description.match(/[^.!?]+[.!?]+/g) || [];
    return sentences.slice(0, 2).join(" ").trim() || description.slice(0, 120);
  })();

  /* ── Image gallery ── */
  const galleryImages = useMemo(() => {
    const candidates = [
      // Primary: nested images array from category-variants API
      ...(Array.isArray(item?.images)
        ? item.images.map((img) => img?.image?.image || img?.image || img)
        : []),
      // Fallback: product_images
      ...(Array.isArray(item?.product_images)
        ? item.product_images.map((img) => img?.image?.image || img?.image || img)
        : []),
    ].filter(Boolean);
    const seen = new Set();
    return candidates.filter((src) => {
      if (typeof src !== "string" || seen.has(src)) return false;
      seen.add(src);
      return true;
    });
  }, [item]);

  const activeImageSrc = selectedImage || galleryImages[0] || "";
  const currentImageIndex = galleryImages.indexOf(activeImageSrc);

  const handlePrevImage = () => {
    if (galleryImages.length <= 1) return;
    const idx = currentImageIndex > 0 ? currentImageIndex - 1 : galleryImages.length - 1;
    setSelectedImage(galleryImages[idx]);
    setImage(galleryImages[idx]);
  };

  const handleNextImage = () => {
    if (galleryImages.length <= 1) return;
    const idx = currentImageIndex < galleryImages.length - 1 ? currentImageIndex + 1 : 0;
    setSelectedImage(galleryImages[idx]);
    setImage(galleryImages[idx]);
  };

  /* ── Cart helpers ── */
  const getProductQuantity = (productId) => {
    const product = cart?.products?.find((p) => p.id === productId);
    return product ? product.quantity : 0;
  };
  const currentQuantity = getProductQuantity(item.id);

  const showMaxQuantityMessage = () => {
    setShowMessage(true);
    setTimeout(() => setShowMessage(false), 2000);
  };

  const addToCart = () => {
    if (isRentMode) {
      setEditingConfigId(null);
      setShowConfigureModal(true);
      return;
    }
    const qty = getProductQuantity(item.id);
    const maxQty = item.max_qty || 10;
    const minQty = item.min_qty || 1;
    if (qty >= maxQty) { showMaxQuantityMessage(); return; }
    dispatch(addProduct({
      product: {
        id: item.id,
        name: item.name,
        image: resolveFirstImage(item),   // actual URL, not numeric ID
        price: itemPrice,
        offer_price: itemOfferPrice || itemPrice,
        weight_in_kg: item.weight_in_kg,
        max_qty: item.max_qty,
        min_qty: minQty,
        subcategory: item.subcategory,
        speed: item.category,
      },
      quantity: qty > 0 ? 1 : minQty,
    }));
    toast.success("Product Added to Cart");
  };

  const removeFromCart = () => {
    const qty = getProductQuantity(item.id);
    const minQty = item.min_qty || 1;
    dispatch(removeProduct({ productId: item.id, quantity: qty > minQty ? 1 : minQty }));
    toast.success("Product Removed from Cart");
  };

  /* ── API helpers ── */
  const getBrandName = async (id) => {
    try {
      const res = await axiosConfig.get(`/catlog/brands/${id}/`);
      setBrandName(res.data.brand_name);
    } catch { /* ignore */ }
  };

  const GetShopDeals = async () => {
    try {
      const res = await axiosConfig.get(`/cms/shopdeals/`);
      setShopDeals(res.data.results[0]);
    } catch { /* ignore */ }
  };

  /* ── Effects ── */
  useEffect(() => {
    if (!item) return;

    console.log("Variant ID:", item.id);

    axiosConfig
      .get(`/catlog/variant-price-packages/?product_variant=${item.id}&active=true`)
      .then((res) => {
        console.log("Packages:", res.data.results);
        const packages = res.data.results || [];
        setPricePackages(packages);

        // Auto-select first available plan if current is not available
        if (packages.length > 0) {
          const currentPlanStr = rentalPlan.toLowerCase();
          const isCurrentAvailable = packages.some(
            (pkg) => (pkg.package_name || "").toLowerCase() === currentPlanStr
          );
          if (!isCurrentAvailable) {
            const firstAvailable = packages[0].package_name;
            if (firstAvailable) {
              const matchedPlan = ALL_CANONICAL_PLANS.find(
                (p) => p.label.toLowerCase() === firstAvailable.toLowerCase()
              );
              setRentalPlan(matchedPlan ? matchedPlan.key : firstAvailable.toLowerCase());
            }
          }
        }
      })
      .catch((err) => {
        console.log(err);
        setPricePackages([]);
      });
  }, [item]);

  useEffect(() => {
    if (!item?.id) return;
    const stored = loadStoredConfigs(item.id);
    const liveIds = new Set(rentCart.map((r) => r.cartItemId));
    const active = stored.filter((c) => liveIds.has(c.id));
    setRentConfigurations(active);
    setEditingConfigId(null);
    if (active.length !== stored.length) saveStoredConfigs(item.id, active);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item?.id]);

  useEffect(() => {
    if (!item?.id) return;
    const liveIds = new Set(rentCart.map((r) => r.cartItemId));
    setRentConfigurations((prev) => {
      const next = prev.filter((c) => liveIds.has(c.id));
      if (next.length !== prev.length) saveStoredConfigs(item.id, next);
      return next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rentCart]);

  useEffect(() => {
    if (item.brand?.id) getBrandName(item.brand.id);
    if (!shopdeals) GetShopDeals();
  }, []);

  useEffect(() => {
    const src = resolveFirstImage(item);
    setImage(src);
    setSelectedImage(src);
  }, [item]);

  const handleNavigate = (path, obj) => {
    navigate(path, { state: { brand_id: obj.brand?.id, subcategory_id: obj.subcategory_obj?.id } });
  };

  /* ── Rental modal helpers ── */
  const buildCartItemId = (plan, duration, startDate) =>
    `${item.id}-${plan}-${duration}-${startDate}-${Date.now()}`;

  const addRentConfigToCart = (configData, cartItemId) => {
    const offerPrice = configData.rentalCharges?.final_cost
      ? Number(configData.rentalCharges.final_cost) / Math.max(1, Number(configData.qty))
      : configData.selectedPackage
        ? Number(configData.selectedPackage.offer_price) / Number(configData.selectedPackage.duration_value || 1)
        : Number(item.rental_price || 0);

    dispatch(addToRentCart({
      cartItemId,
      id: item.id,
      name: item.name,
      image: Image,
      type: "rent",
      rentalPlan: configData.plan,
      duration: configData.duration,
      qty: configData.qty,
      selectedPackage: configData.selectedPackage,
      offerPrice,
      rental_price: item.rental_price,
      fromDate: configData.startDate,
      toDate: configData.endDate || null,
      rentalCharges: configData.rentalCharges || null,
    }));
    toast.success("Product Added to Cart");
  };

  const handleConfigureSubmit = (configData) => {
    const planLabel = ALL_CANONICAL_PLANS.find((p) => p.key === configData.plan)?.label || "Rental";
    const configEntry = {
      id: editingConfigId || buildCartItemId(configData.plan, configData.duration, configData.startDate),
      plan: configData.plan,
      qty: configData.qty,
      duration: configData.duration,
      startDate: configData.startDate,
      endDate: configData.endDate || null,
      price: configData.price,
      originalPrice: configData.originalPrice,
      discountPercent: configData.discountPercent,
      selectedPackage: configData.selectedPackage,
      rentalCharges: configData.rentalCharges || null,
      label: `${planLabel} Rental`,
    };

    if (editingConfigId) {
      dispatch(removeFromRentCart(editingConfigId));
      addRentConfigToCart(configData, configEntry.id);
      setRentConfigurations((prev) => {
        const next = prev.map((c) => (c.id === editingConfigId ? configEntry : c));
        saveStoredConfigs(item.id, next);
        return next;
      });
      toast.success("Configuration updated");
    } else {
      addRentConfigToCart(configData, configEntry.id);
      setRentConfigurations((prev) => {
        const next = [...prev, configEntry];
        saveStoredConfigs(item.id, next);
        return next;
      });
      toast.success("Configuration added to cart");
    }

    setEditingConfigId(null);
    setShowConfigureModal(false);
  };

  const handleEditConfig = (configId) => { setEditingConfigId(configId); setShowConfigureModal(true); };
  const handleDeleteConfig = (configId) => {
    dispatch(removeFromRentCart(configId));
    toast.success("Product Removed from Cart");
    setRentConfigurations((prev) => {
      const next = prev.filter((c) => c.id !== configId);
      saveStoredConfigs(item.id, next);
      return next;
    });
    toast.success("Configuration removed");
  };
  const handleCloseConfigureModal = () => { setShowConfigureModal(false); setEditingConfigId(null); };

  const editingConfig = rentConfigurations.find((c) => c.id === editingConfigId);

  return (
    <main className="pd-page">
      <div className="pd-wrap">

        {/* ══════════════════════════════════════════
            2-COLUMN PRODUCT CARD
        ══════════════════════════════════════════ */}
        <div className="pd-shell">

          {/* ── LEFT — image panel ─────────────────── */}
          <div className="pd-left">
            <div className="pd-left-inner">

              {/* Brand / model label */}
              <div className="pd-brand-block">
                {/* <div className="pd-brand-logo">
                  {item.brand?.brand_name || brandName || "BGB"}
                </div> */}
                {(item.subcategory_name?.[0] || item.subcategory_slug) && (
                  <div className="pd-model-label">
                    {item.subcategory_name?.[0] || item.subcategory_slug}
                  </div>
                )}
                {item.code && (
                  <div className="pd-model-code">Model {item.code}</div>
                )}
              </div>

              {/* Main image frame with arrows */}
              <div className="pd-img-frame">
                {galleryImages.length > 1 && (
                  <button className="pd-img-nav prev" onClick={handlePrevImage} aria-label="Previous image">
                    <FiChevronLeft />
                  </button>
                )}
                <img
                  src={activeImageSrc}
                  alt={item?.name}
                  onError={(e) => { e.target.style.display = "none"; }}
                />
                {galleryImages.length > 1 && (
                  <button className="pd-img-nav next" onClick={handleNextImage} aria-label="Next image">
                    <FiChevronRight />
                  </button>
                )}
              </div>

              {/* Thumbnail strip */}
              {galleryImages.length > 1 && (
                <div className="pd-thumbs" aria-label="Product images">
                  {galleryImages.map((src, index) => (
                    <button
                      key={`${src}-${index}`}
                      type="button"
                      className={`pd-thumb${activeImageSrc === src ? " active" : ""}`}
                      onClick={() => { setSelectedImage(src); setImage(src); }}
                      aria-label={`View image ${index + 1}`}
                    >
                      <img src={src} alt="" onError={(e) => { e.target.style.display = "none"; }} />
                    </button>
                  ))}
                </div>
              )}

              {/* ProductMultipleImages — hidden driver for extra images */}
              {item && (
                <div style={{ display: "none" }}>
                  <ProductMultipleImages
                    id={item.id}
                    Image={Image}
                    setImage={(src) => { setImage(src); setSelectedImage(src); }}
                  />
                </div>
              )}

              {/* Wishlist button */}
              <button
                className={`pd-wish-btn${inWishlist ? " active" : ""}`}
                type="button"
                onClick={toggleWishlist}
                aria-label={inWishlist ? "Remove from wishlist" : "Save to wishlist"}
              >
                {inWishlist ? <AiFillHeart color="#735CEB" /> : <AiOutlineHeart color="currentColor" />}
                <span>
                  {inWishlist ? "Saved to wishlist" : "Save to wishlist"}
                </span>
              </button>

            </div>
          </div>

          {/* ── RIGHT — info panel ─────────────────── */}
          <div className="pd-right">

            <div className='product-right-listingtype' style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
              <div style={{ textTransform: "uppercase", fontWeight: "600", fontSize: "14px", color: "#333" }}>{item.varient_listing_type || orderMode}</div>
            </div>

            {/* Breadcrumbs */}
            <BreadCrumbs
              active_page={props.item.name}
              sub_page={props.all_props?.categoryurl}
              prev_sub_page={props.all_props?.subcategoryurl}
            />

            {/* Product title */}
            <div className="pd-title-block">
              <h1 className="pd-name">{item.name}</h1>
              {brandName && (
                <div
                  className="all-by-brand"
                  onClick={() =>
                    handleNavigate(`/${item.category_slug}/${item.subcategory_slug}`, item)
                  }
                  style={{ marginBottom: 8 }}
                >
                  {`View all by ${brandName}`}
                  <AiFillCaretRight size={12} />
                </div>
              )}
              {shortDescText && (
                <p className="pd-short-desc">{shortDescText}</p>
              )}
            </div>

            {/* Expandable full description */}
            {description && description.length > shortDescText.length && (
              <div style={{ marginBottom: 16 }}>
                {showFullDescription && (
                  <p className="pd-desc-text">{description}</p>
                )}
                {description.length > 120 && (
                  <button
                    type="button"
                    className="pd-read-more"
                    onClick={() => setShowFullDescription((p) => !p)}
                  >
                    {showFullDescription ? "Read Less" : "Read More"}
                  </button>
                )}
              </div>
            )}

            {/* Spec grid */}
            <div className="pd-spec-row">
              {item.weight && (
                <div className="pd-spec-item">
                  <span className="pd-spec-label">Weight</span>
                  <span className="pd-spec-val">{item.weight} {item.measurement_unit}</span>
                </div>
              )}
              {item.code && (
                <div className="pd-spec-item">
                  <span className="pd-spec-label">Model Code</span>
                  <span className="pd-spec-val">{item.code}</span>
                </div>
              )}
              {item.brand?.brand_name && (
                <div className="pd-spec-item">
                  <span className="pd-spec-label">Brand</span>
                  <span className="pd-spec-val">{item.brand.brand_name}</span>
                </div>
              )}
              {(item.subcategory_name?.[0] || item.subcategory_slug) && (
                <div className="pd-spec-item">
                  <span className="pd-spec-label">Category</span>
                  <span className="pd-spec-val">
                    {item.subcategory_name?.[0] || item.subcategory_slug}
                  </span>
                </div>
              )}
            </div>

            <hr style={{ borderColor: "#eee", margin: "0 0 18px" }} />

            {/* ── BUY / RENT TOGGLE ── */}
            <div className="pd-purchase-panel">
              <div className="pd-mode-toggle-wrapper">
                <div className="pd-mode-toggle" aria-label="Select purchase type">
                  <label className={`pd-mode-option${orderMode === "buy" ? " active" : ""}`}>
                    <input
                      type="radio"
                      name="orderMode"
                      value="buy"
                      checked={orderMode === "buy"}
                      onChange={() => setOrderMode("buy")}
                    />
                    <span className="pd-mode-copy"><strong>BUY</strong></span>
                  </label>
                  <label className={`pd-mode-option${orderMode === "rent" ? " active" : ""}`}>
                    <input
                      type="radio"
                      name="orderMode"
                      value="rent"
                      checked={orderMode === "rent"}
                      onChange={() => setOrderMode("rent")}
                    />
                    <span className="pd-mode-copy"><strong>RENT</strong></span>
                  </label>
                </div>
              </div>

              {/* Rental plan pills — shown in rent mode before any config is added */}
              {orderMode === "rent" && rentConfigurations.length === 0 && (
                <>
                  <div className="pd-rental-plan-label">Rental Plan</div>
                  <div className="pd-rental-plan-pills">
                    {ALL_CANONICAL_PLANS.map((plan) => {
                      const isAvailable = pricePackages.some(
                        (pkg) => (pkg.package_name || "").toLowerCase() === plan.label.toLowerCase()
                      );
                      return (
                        <button
                          key={plan.key}
                          type="button"
                          className={`pd-pill${rentalPlan === plan.key ? " active" : ""}${!isAvailable ? " unavailable" : ""}`}
                          onClick={() => isAvailable && setRentalPlan(plan.key)}
                          disabled={!isAvailable}
                          title={!isAvailable ? `${plan.label} plan not available` : ""}
                        >
                          <span className="pd-pill-label">{plan.label}</span>
                          {!isAvailable && <span className="pd-pill-na">N/A</span>}
                        </button>
                      );
                    })}
                  </div>
                </>
              )}

              {/* Price display */}
              <div className="pd-price-cards">
                {orderMode === "buy" ? (
                  <div className="pd-price-card">
                    <div className="pd-price-row">
                      <strong className="pd-amount">{displayBuyPrice}</strong>
                      {hasBuyDiscount && <del className="pd-original">{originalBuyPrice}</del>}
                      {item.discount_percentage > 0 && hasBuyDiscount && (
                        <span className="pd-save">{item.discount_percentage}% off</span>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="pd-price-card">
                    <div className="pd-price-row">
                      <strong className="pd-amount">{displayRentPrice}</strong>
                      <span className="pd-price-period">/ {currentPlan.period}</span>
                      {rentHasDiscount && (
                        <del className="pd-original">{formatRupee(activePackage.price)}</del>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* ── RENTAL CONFIGURATIONS LIST ── */}
            {orderMode === "rent" && rentConfigurations.length > 0 && (
              <div className="pd-config-section">
                <h3 className="pd-config-heading">Rental Configurations</h3>
                {rentConfigurations.map((config) => (
                  <div className="pd-config-card" key={config.id}>
                    <div className="pd-config-accent" />
                    <div className="pd-config-body">
                      <div className="pd-config-main">
                        <span className="pd-config-tag">{config.plan.toUpperCase()}</span>
                      </div>
                      <div className="pd-config-meta">
                        <div className="pd-config-meta-item">
                          <span className="pd-config-meta-label">Qty</span>
                          <span className="pd-config-meta-value">
                            {String(config.qty).padStart(2, "0")}
                          </span>
                        </div>
                        <div className="pd-config-meta-item">
                          <span className="pd-config-meta-label">Duration</span>
                          <span className="pd-config-meta-value">
                            {formatDurationDisplay(config.duration, config.plan)}
                          </span>
                        </div>
                        <div className="pd-config-meta-item">
                          <span className="pd-config-meta-label">Start Date</span>
                          <span className="pd-config-meta-value">{config.startDate}</span>
                        </div>
                        <div className="pd-config-price-wrapper">
                          <div className="pd-config-price">{formatRupee(config.price)} </div>
                        </div>
                      </div>
                    </div>
                    <div className="pd-config-actions">
                      <button
                        type="button"
                        className="pd-config-action-btn"
                        onClick={() => handleEditConfig(config.id)}
                        aria-label="Edit configuration"
                      >
                        <FiEdit2 />
                      </button>
                      <button
                        type="button"
                        className="pd-config-action-btn pd-config-action-btn--delete"
                        onClick={() => handleDeleteConfig(config.id)}
                        aria-label="Delete configuration"
                      >
                        <FiTrash2 />
                      </button>
                    </div>
                  </div>
                ))}
                <button
                  type="button"
                  className="pd-config-add-btn"
                  onClick={() => { setEditingConfigId(null); setShowConfigureModal(true); }}
                >
                  + Add Another Configuration
                </button>
              </div>
            )}

            {/* ── ACTION BUTTON ── */}
            <div className="pd-actions">
              {orderMode === "buy" ? (
                (cart?.products || []).some((p) => p.id === item.id) ? (
                  <div className="pd-qty-stepper">
                    <button className="pd-qty-btn" type="button" onClick={removeFromCart}>−</button>
                    <div className="pd-qty-display">{currentQuantity}</div>
                    <button className="pd-qty-btn" type="button" onClick={addToCart}>+</button>
                  </div>
                ) : (
                  <button className="pd-cart-cta" type="button" onClick={addToCart}>
                    Add to Cart
                  </button>
                )
              ) : (
                rentConfigurations.length === 0 && (
                  <button className="pd-cart-cta" type="button" onClick={addToCart}>
                    Add to Cart
                  </button>
                )
              )}
            </div>

            {showMessage && (
              <div className="custom-message" style={{ marginTop: 10 }}>
                Sorry, you have reached maximum quantity.
              </div>
            )}

            {/* ── WHY US ── */}
            {shopdeals && (
              <div className="pd-why-section why-us">
                <p className="why-title">{shopdeals?.main_title}</p>
                <div className="why-cards">
                  {(shopdeals?.subtitle_1 || shopdeals?.description1) &&
                    !(shopdeals?.subtitle_1 === "undefined" || shopdeals?.description1 === "undefined") && (
                      <div className="row align-items-center">
                        <div className="col-2 d-flex justify-content-center">
                          {shopdeals?.image1 ? <img src={shopdeals.image1} alt="" /> : <TiTick size={20} />}
                        </div>
                        <div className="col-10">
                          <p className="why-bold-text">{shopdeals?.subtitle_1}</p>
                          <p className="why-text-color">{shopdeals?.description1}</p>
                        </div>
                      </div>
                    )}
                  {(shopdeals?.subtitle_2 || shopdeals?.description2) &&
                    !(shopdeals?.subtitle_2 === "undefined" || shopdeals?.description2 === "undefined") && (
                      <div className="row align-items-center">
                        <div className="col-2 d-flex justify-content-center">
                          {shopdeals?.image2 ? <img src={shopdeals.image2} alt="" /> : <TiTick size={20} />}
                        </div>
                        <div className="col-10">
                          <p className="why-bold-text">{shopdeals?.subtitle_2}</p>
                          <p className="why-text-color">{shopdeals?.description2}</p>
                        </div>
                      </div>
                    )}
                  {(shopdeals?.subtitle_3 || shopdeals?.description3) &&
                    !(shopdeals?.subtitle_3 === "undefined" || shopdeals?.description3 === "undefined") && (
                      <div className="row align-items-center">
                        <div className="col-2 d-flex justify-content-center">
                          {shopdeals?.image3 ? <img src={shopdeals.image3} alt="" /> : <TiTick size={20} />}
                        </div>
                        <div className="col-10">
                          <p className="why-bold-text">{shopdeals?.subtitle_3}</p>
                          <p className="why-text-color">{shopdeals?.description3}</p>
                        </div>
                      </div>
                    )}
                </div>
              </div>
            )}

            {/* Popups */}
            {LocationpopupType === "success" && (
              <LocationModal
                LocationpopupType={LocationpopupType}
                setLocationpopupType={setLocationpopupType}
              />
            )}
            {NoAccess === "success" && (
              <AccessDeny NoAccess={NoAccess} setNoAccess={setNoAccess} />
            )}

          </div>
        </div>

        {/* Full product description — below the card */}
        {item.description && (
          <div className="product-description" style={{ paddingBottom: 40 }}>
            <p className="desc-title">Product Details</p>
            <p dangerouslySetInnerHTML={{ __html: item.description }} />
          </div>
        )}

      </div>

      {/* Similar Products */}
      <Products
        products_for="Similar Products"
        productId={item.id}
        listingType={item.listing_type === "sale" ? "buy" : item.listing_type}
        varientId={item.varients ? item.id : ""}
      />

      {/* ── Configure Rental Drawer ── */}
      <ConfigureRentalModal
        show={showConfigureModal}
        onHide={handleCloseConfigureModal}
        product={{
          id: item.id,
          variant_id: item.id,
          name: item.name,
          image: Image,
          code: item.code,
          subcategory_name: item.subcategory_name,
          rental_price: item.rental_price,
        }}
        initialPlan={editingConfig?.plan || rentalPlan}
        initialQty={editingConfig?.qty || 1}
        initialDuration={editingConfig?.duration || 1}
        initialStartDate={editingConfig?.startDate || ""}
        packages={pricePackages}
        onSubmit={handleConfigureSubmit}
      />
      {loginShow && (
        <LoginModal
          setLoginType={setLoginShow}
          LoginType={loginShow}
          setLoggedIn={Setlogin}
          LoggedIn={LoginAccount}
        />
      )}
    </main>
  );
};

export { ProductDetail };